import React from "react";
import classnames from "classnames";
import { GeneralIcon, type GeneralIcons } from "modules/common/components/planr/icon/Generalcon";
import styles from "./EmptyState.module.scss";

export interface EmptyStateProps {
    title: string;
    description?: string;
    icon?: GeneralIcons;
    /** Кнопки действий под текстом */
    children?: React.ReactNode;
    className?: string;
}

/**
 * Экран-состояние по центру: «Пусто», «Нет доступа», «Нужна сеть», «Не удалось загрузить».
 * Заголовок, пояснение человеческим языком и кнопки того, что можно сделать дальше.
 */
export const EmptyState = ({ title, description, icon, children, className }: EmptyStateProps) => (
    <div className={classnames(styles.state, className)}>
        {icon && <GeneralIcon type={icon} size={48} className={styles.icon} />}
        <h2 className={styles.title}>{title}</h2>
        {description && <p className={styles.description}>{description}</p>}
        {children && <div className={styles.actions}>{children}</div>}
    </div>
);
